import axios from 'axios';
import Dashboard from './views/Dashboard';
import TopMenu from './components/TopMenu';
import SignUp from './views/SignUp';
import SignIn from './views/SignIn';
import NewCheckers from './views/NewCheckers';
import NewCards from './views/NewCards';
import BrowseGame from './views/BrowseGame';
import BrowseProfile from './views/BrowseProfile';
import BrowseLeague from './views/BrowseLeague';
import PlayGame from './views/PlayGame';
import ChatMain from './views/ChatMain';
import AlertsMain from './views/AlertsMain';
import AllMatches from './views/AllMatches';
import AllLeagues from './views/AllLeagues';
import ChatView from './views/ChatViewOld';
import Account from './views/Account';
import ChangePassword from './views/ChangePassword';
import PhoneLink from './views/PhoneLink';
import EmailLink from './views/EmailLink';
import YourAwards from './views/YourAwards';
import CoinsHistory from './views/CoinsHistory';
import MoreSettings from './views/MoreSettings';
import CoinsShop from './views/CoinsShop';
import More from './views/More';
import RecentUsers from './views/RecentUsers';
import ResetPwd from './views/ResetPwd';
import ChatRoom from './views/ChatRoom';
import Friends from './views/Friends';
import NewLeague from './views/NewLeague';

export const BASE_API = '/soldrax_app/api/';
//export const BASE_API = 'github_projects/soldrax/api/';

export const GAME_SERVER = 'https://soldrax.werenium.com/game-server/';
//export const GAME_SERVER = 'game-server/';

export const WEB_SOCKET_URL = "wss://soldrax.werenium.com/";
//export const WEB_SOCKET_URL = "ws://192.168.159.36:8000";

export function getViewerView(type, id) {
  if(type === 'chat') {
    return <ChatMain/>;
  } else if(type === 'game' && id) {
    return <BrowseGame gameId={id}/>;
  } else if(type === 'change_password' && !id) {
    return <ChangePassword/>;
  } else if(type === 'phone_link' && !id) {
    return <PhoneLink/>;
  } else if(type === 'email_link' && !id) {
    return <EmailLink/>;
  } else if(type === 'your_awards' && !id) {
    return <YourAwards/>;
  } else if(type === 'coins_history' && !id) {
    return <CoinsHistory/>;
  } else if(type === 'more_settings' && !id) {
    return <MoreSettings/>;
  } else if(type === 'browse_league' && id) {
    return <BrowseLeague leagueId={id}/>;
  } else if(type === 'browse_game' && id) {
    return <BrowseGame gameId={id}/>;
  } else if(type === 'browse_profile' && id) {
    return <BrowseProfile id={id}/>;
  } else if(type === 'chatroom' && id) {
    return <ChatRoom chatId={id}/>;
  } 
}

export function giv(id) {
  return document.getElementById(id).value;
}

export function getView(app) {
  //resolve views

  if(!app.navItem && !app.navSubItem && !app.navExtraItem) {
    return <Dashboard/>;
  } else if(app.navItem === 'signin' && !app.navSubItem && !app.navExtraItem) {
    return <SignIn/>;
  } else if(app.navItem === 'signup' && !app.navSubItem && !app.navExtraItem) {
    return <SignUp/>;
  } else if(app.navItem === 'reset_pwd' && !app.navSubItem && !app.navExtraItem) {
    return <ResetPwd/>;
  } else if(app.navItem === 'new_checkers' && !app.navSubItem && !app.navExtraItem) {
    return <NewCheckers/>;
  } else if(app.navItem === 'new_cards' && !app.navSubItem && !app.navExtraItem) {
    return <NewCards/>;
  } else if(app.navItem === 'new_league' && !app.navSubItem && !app.navExtraItem) {
    return <NewLeague/>;
  } else if(app.navItem === 'chat' && !app.navSubItem && !app.navExtraItem) {
    return <ChatMain/>;
  } else if(app.navItem === 'matches' && !app.navSubItem && !app.navExtraItem) {
    return <AllMatches/>;
  } else if((app.navItem === 'friends' || app.navItem === 'friend_requests') && !app.navSubItem && !app.navExtraItem) {
    return <Friends/>;
  } else if(app.navItem === 'leagues' && !app.navSubItem && !app.navExtraItem) {
    return <AllLeagues/>;
  } else if(app.navItem === 'account' && !app.navSubItem && !app.navExtraItem) {
    return <Account/>;
  } else if(app.navItem === 'coins_shop' && !app.navSubItem && !app.navExtraItem) {
    return <CoinsShop/>;
  } else if(app.navItem === 'alerts' && !app.navSubItem && !app.navExtraItem) {
    return <AlertsMain/>;
  } else if(app.navItem === 'more' && !app.navSubItem && !app.navExtraItem) {
    return <More/>;
  } else if(app.navItem === 'recent_users' && !app.navSubItem && !app.navExtraItem) {
    return <RecentUsers/>;
  } else if(app.navItem === 'chat' && app.navSubItem) {
    return <ChatView chatRoomId={app.navSubItem}/>;
  } else if(app.navItem === 'browse_game' && app.navSubItem && !app.navExtraItem) {
    return <BrowseGame gameId={app.navSubItem}/>;
  } else if(app.navItem === 'browse_profile' && app.navSubItem && !app.navExtraItem) {
    return <BrowseProfile id={app.navSubItem}/>;
  } else if(app.navItem === 'browse_league' && app.navSubItem && !app.navExtraItem) {
    return <BrowseLeague leagueId={app.navSubItem}/>;
  } else if(app.navItem === 'chatroom' && app.navSubItem && !app.navExtraItem) {
    return <ChatRoom chatId={app.navSubItem}/>;
  } else if(app.navItem === 'play_game' && app.navSubItem && !app.navExtraItem) {
    return <PlayGame gameId={app.navSubItem}/>;
  } else if(app.navItem === "view") {
    return getViewerView(app.navSubItem, app.navExtraItem);
  } else {
    return <Dashboard/>
  }
}

export async function copyText(text) {
  //navigator.clipboard.writeText(text);
  try {
    window.calipaApp.copyText(text);
  } catch (e) {
    //probably running on web
    await forceCopy(text).then(response => {
      //alert(response)
    }).catch((e) => {
      //alert(e.message)
    });
  }
}

export function trimString(inputString) {
  if (inputString.length <= 10) {
    return inputString;
  } else {
    return inputString.slice(0, 10) + '...';
  }
}

export function forceCopy(text) {
  return new Promise(async (resolve, reject) => {
    if (typeof navigator !== "undefined" && typeof navigator.clipboard !== "undefined" && navigator.permissions !== "undefined") {
      // const type = "text/plain";
      // const blob = new Blob([text], { type });
      // const data = [new ClipboardItem({ [type]: blob })];
      // navigator.permissions.query({name: "clipboard-write"}).then((permission) => {
      //     if (permission.state === "granted" || permission.state === "prompt") {
      //         navigator.clipboard.write(data).then(resolve, reject).catch(reject);
      //     }
      //     else {
      //         reject(new Error("Permission not granted!"));
      //     }
      // });
      await navigator.clipboard.writeText(text).then(() => { });
    }
    else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
      var textarea = document.createElement("textarea");
      textarea.textContent = text;
      textarea.style.position = "fixed";
      textarea.style.width = '2em';
      textarea.style.height = '2em';
      textarea.style.padding = 0;
      textarea.style.border = 'none';
      textarea.style.outline = 'none';
      textarea.style.boxShadow = 'none';
      textarea.style.background = 'transparent';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
          document.execCommand("copy");
          document.body.removeChild(textarea);
          resolve();
      }
      catch (e) {
          document.body.removeChild(textarea);
          reject(e);
      }
    }
    else {
      reject(new Error("None of copying methods are supported by this browser!"));
    }
  });

}


export function getCoordinate(clientX, clientY, inverted=false) {
  let boardWidth = document.getElementById('ChessBoard').clientWidth;
  let boardHeight = document.getElementById('ChessBoard').clientHeight;
  let cellWidth = boardWidth/8;
  let cellHeight = boardHeight/8;
  let wids = [];
  let heis = [];
  let _x, _y;

  for (let i = 1; i <= 8; i++) {
    wids.push({
      coor: i,
      min: (cellWidth * (i - 1)),
      max: (cellWidth * i),
    })

    heis.push({
      coor: (!inverted) ? 9 - i : i,
      min: (cellHeight * (i - 1)),
      max: (cellHeight * i),
    })
  }

  wids.forEach((item, i) => {
    if(clientX > item.min && clientX < item.max) {
      _x = item.coor;
    }
  })

  heis.forEach((item, i) => {
    if(clientY > item.min && clientY < item.max) {
      _y = item.coor;
    }
  })

  return [ _x, _y];
}

export function resolveOrientation(orientation) {
  return String(orientation).split('-')[0];
}

export function isAlphanumeric(str) {
  let regexp = new RegExp(/^[a-zA-Z0-9-_]+$/);
  return regexp.test(str);
}

export function formatDate(timestamp, fromPhp = true) {
  timestamp = (fromPhp) ? Number(timestamp) * 1000 : timestamp;
  let date = new Date(timestamp);
  return (date.toLocaleString());
}

export function getLocalUser() {
  return new Promise(async resolve => {
    //use cookies
    let userId = getCookie('userId');
    let userToken = getCookie('userToken');
    
    if(userId && userToken) {
      resolve({
        userId,
        userToken,
      })
    } else {
      resolve(null);
    }

  })
}

export function callApi (url, params) {
  console.log("called deprecated function");
  return null;
  /*
  return new Promise(async resolve => {
    //call main api
    let formData = new FormData();
    for (let key in params) {
      formData.append(key, params[key]);
    }

    axios.post(BASE_API+url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then(response => {
      //console.log(url);
      console.log(response.data);
      resolve(response.data);
    }).catch(error => {
      resolve({
        status: 0,
        msg: "Network Connection Error",
      })
    })
  })
  */
}

export function generateRandomString(length = 6) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomString += characters.charAt(randomIndex);
  }

  return randomString;
}

export function callGameServerApi (url, params) {
  return new Promise(async resolve => {
    //get local user
    const user = await getLocalUser();
    //call main api
    let formData = new FormData();
    for (let key in params) {
      formData.append(key, params[key]);
    }

    if(user) {
      if(!params.userId) {
        formData.append('userId', user.userId);
      }

      if(!params.userToken) {
        formData.append('userToken', user.userToken);
      }
    }

    axios.post(GAME_SERVER+url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then(response => {
      console.log(url);
      console.log(response.data);
      resolve(response.data);
    }).catch(error => {
      resolve({
        status: 0,
        msg: "Network Connection Error",
      })
    })
  })
}


export function getInlineLoader (type) {
  return (
    <div className="Loader" data-type={type}>
    </div>
  );
}

export function formatMoney(x) {
  //round x to 2 decimal places before og function
  x = Number(x);
  x = x.toFixed(0);

  //then continue
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function formatMoneyShorten(num, digits = 2) {
  num = Number.parseFloat(num);
  if(num <= 1 && num >= -1 ) {
    return num;
  }

  const lookup = [
   { value: 1, symbol: "" },
   { value: 1e3, symbol: "K" },
   { value: 1e6, symbol: "M" },
   { value: 1e9, symbol: "B" },
   { value: 1e12, symbol: "T" },
   { value: 1e15, symbol: "P" },
   { value: 1e18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function(item) {
    return num >= item.value;
  });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export function processTimer(gameData) {
  let timerDiff = Number(gameData.sessionTimer) - (Date.now() / 1000);
  if(timerDiff > 0) {
    let minutes = Math.trunc(timerDiff/60);
    let seconds = Math.trunc(timerDiff % 60);
    if(seconds < 10) {
      seconds = "0"+String(seconds);
    }

    if(minutes < 10) {
      minutes = "0"+String(minutes);
    }

    return (String(minutes)+":"+String(seconds))

  } else {
    return "00:00";
  }
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


export function processTimerLc(gameData) {
  if(JSON.parse(gameData.boardData).specialEffect) {
    let timerDiff = Number(JSON.parse(gameData.boardData).specialEffect.expiry) - (Date.now() / 1000);
    if(timerDiff > 0) {
      let minutes = Math.trunc(timerDiff/60);
      let seconds = Math.trunc(timerDiff % 60);
      if(seconds < 10) {
        seconds = "0"+String(seconds);
      }

      if(minutes < 10) {
        minutes = "0"+String(minutes);
      }

      return (String(minutes)+":"+String(seconds))

    } else {
      return "00:00";
    }
  } else {
    return "00:00";
  }

}
